import { Component, OnInit } from '@angular/core';
import { EditFormBase } from '../../../core/helper/editFormBase';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { SessionHelper } from '../../../core/helper/sessionHelper';
import { Location } from '@angular/common';
import { A3LCompanyWorkplaces } from '../../../core/models/a3LCompanyWorkplaces.model';
import { A3LCompanyService } from '../../../core/services/a3LCompany.service';
import { A3LEmployee } from '../../../core/models/a3LEmployee.model';
import { A3LEmployeeService } from '../../../core/services/a3LEmployee.service';
import { A3LEmployeeHighestCode } from '../../../core/models/a3LEmployeeHighestCode.model';
import { TramosCodigoEmpleadosService } from '../../../core/services/tramosCodigoEmpleados.service';
import {
  A3LEmployeeAddress,
  A3LEmployeeAgreementCreateRequest,
  A3LEmployeeContribution,
  A3LEmployeeCreateRequest,
  A3LEmployeeIdentificationCreateRequest,
} from '../../../core/models/a3LEmployeeCreateRequest.model';
import { A3LCommonService } from '../../../core/services/a3LCommon.service';
import { A3LEmployeeIdentificationDataUpdateRequest } from '../../../core/models/a3LEmployeeIdentificationDataUpdateRequest.model';
import { A3LCompanyAvailableJobPositions } from '../../../core/models/a3LCompanyAvailableJobPositions.model';
import { A3LRegime } from '../../../core/models/a3LRegime.model';
import { A3LTariffGroup } from '../../../core/models/a3LTariffGroup.model';
import { A3LCompanyAgreements } from '../../../core/models/a3LCompanyAgreements.model';
import { isValidCif, isValidNie, isValidNif } from 'nif-dni-nie-cif-validation';
import { EIdentificationType } from '../../../core/Enums/EIdentificationType.enum';
import { SweetAlertIcon } from 'sweetalert2';
import { EEntityMode } from '../../../core/Enums/EEntityMode.enum';
import { A3LCommonDataEntity } from '../../../core/models/a3LCommonDataEntity.model';
import { PageList } from '../../../core/models/pageList.model';

@Component({
  selector: 'app-gestion-empleados-detail',
  templateUrl: './gestion-empleados-detail.component.html',
  styleUrls: ['./gestion-empleados-detail.component.scss'],
  providers: [
    A3LEmployeeService,
    TramosCodigoEmpleadosService,
    A3LCompanyService,
    A3LCommonService,
  ],
})
export class GestionEmpleadosDetailComponent
  extends EditFormBase<A3LEmployee, string>
  implements OnInit
{
  panelIcon = 'user'; // Awesome icon
  panelTitle = 'Empleado';
  panelDescription = '';
  loading: boolean = false;
  
  TIPO_TRABAJADOR_ETT: string = 'ETT';
  GRUPO_TARIFA_OFICIALES_PRIMERA_SEGUNDA: number = 8;
  TIPO_COTIZACION_GENERAL: number = 1;

  centros: A3LCompanyWorkplaces[];
  personTypes: A3LCommonDataEntity[] = [];
  sexTypes: A3LCommonDataEntity[] = [];
  contributionTypes: A3LCommonDataEntity[] = [];
  identificationTypes: A3LCommonDataEntity[] = [];
  jobPositions: A3LCompanyAvailableJobPositions[];
  regimes: A3LRegime[];
  tariffGroups: A3LTariffGroup[];
  companyAgreements: A3LCompanyAgreements[];

  nifValido: boolean = true;
  numAfiliacionValido: boolean = true;
  mostrarAvisos: boolean = false;
  avisoMensaje: string = '';
  isNew: boolean = true;
  tramoSuperado: boolean = false;
  nifAntiguo: string;
  empleadoExiste: boolean = false;
  fechaValida: boolean = true;

  selectedCompany: number;
  codEmpleado: string;
  centro: number;
  tipoTrabajador: string;
  nif: string;
  nombre: string;
  apellido1: string;
  apellido2: string;
  numAfiliacion: string;
  sexo: string;
  tipoDocumento: number;
  calle: string;
  jobPosition: string;
  contributionType: string;
  regime: string;
  tariffGroup: string;
  companyAgreement: string;
  fechaAlta: Date;

  // Variables de creación de empleado que siempre tienen ese valor.
  ims = 0;
  it = 0;
  paymentFrequency = 1;
  classificationCode = 1;
  subClassificationCode = 0;

  sortFunction = (a: A3LCommonDataEntity, b: A3LCommonDataEntity) => a.description.localeCompare(b.description);

  constructor(
    _route: ActivatedRoute,
    protected _employeeService: A3LEmployeeService,
    protected _A3LCompanyService: A3LCompanyService,
    protected _tramosEmpleadosService: TramosCodigoEmpleadosService,
    protected _A3LCommonService: A3LCommonService,
    _messageDialog: MessageDialog,
    protected _session: SessionHelper,
    _router: Router,
    _location: Location
  ) {
    super(
      _employeeService,
      _messageDialog,
      _route,
      _router,
      _location,
      A3LEmployee
    );
  }

  ngOnInit(): void {
    this.getModel();
    this.getTiposTrabajador();
    this.getSexos();
    this.getTiposIdentificacion();

    this.fechaAlta = new Date();
  }

  getModel() {
    if (!this.id) {
      this.getIdFromRoute();
    }

    this._route.queryParams.subscribe((queryParams) => {
      this.selectedCompany = Number(queryParams['companyCode']);
    });

    if (this.id !== 'new') {
      this.nifValido = true;
      this.isNew = false;
      this._employeeService
        .getIdentificationData(this.selectedCompany, this.id)
        .subscribe(
          (response) => {
            if (response) {
              this.centro = Number(response.workplaceCode);
              this.numAfiliacion = response.ssAffiliationNumber;
              this.tipoTrabajador = response.personTypeID;
              this.nombre = response.name;
              this.apellido1 = response.secondName1;
              this.apellido2 = response.secondName2;
              this.sexo = response.sex;
              this.nif = response.identifierNumber;
              this.nifAntiguo = response.identifierNumber;

            }
          },
          (error) => {
            console.error(error);
          }
        );
    }
  }

  onSubmit(form) {
    let validForm: boolean;

    if (Object.prototype.hasOwnProperty.call(form, form)) {
      validForm = form.form.valid;
    } else {
      validForm = form.valid;
    }

    if (validForm) {
      if (this.id === 'new') {
        this.comprobarTramosValidos();
      } else {
        this.actualizarEmpleado();
      }
    }
  }

  comprobarTramosValidos() {
    this._tramosEmpleadosService
      .obtenerTramosCodigo(this.selectedCompany)
      .subscribe(
        (response) => {
          if (response) {
            if (this.validateSSNumber(this.numAfiliacion)) {
              this.comprobarCreacionEmpleado();
            } else {
              this._messageDialog.ShowAlert(
                'El Nº Afiliación SS no tiene un formato válido. El formato debe ser XX/YYYYYYYY/ZZ',
                'Error'
              );
            }
          } else {
            this._messageDialog.ShowAlert(
              'La empresa no tiene tramos de códigos de empleado definidos.',
              'Error'
            );
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  comprobarCreacionEmpleado() {
    this.loading = true;
    this._employeeService
      .checkHighestEmployeeCode(this.selectedCompany, this.tipoTrabajador)
      .subscribe(
        (response: A3LEmployeeHighestCode) => {
          if (response) {
            this.codEmpleado = response.AssignedCode;
            const tipoTrabajadorDescripcion = this.personTypes.find(
              (tipo) => tipo.id === this.tipoTrabajador
            )?.description;

            this.crearMensajeAviso(
              tipoTrabajadorDescripcion,
              response.HighestCode,
              response.AssignedCode,
              response.TramoSuperado
            );

            if (response.TramoSuperado) {
              this._messageDialog.ShowMessage(
                this.avisoMensaje,
                'Tramo superado',
                'warning'
              );
            } else {
              const mensaje = `${this.avisoMensaje}<br><br> ¿Desea finalizar la creación del empleado y asignar el código propuesto?`;
              this.loading = false;
              this._messageDialog
                .ShowQuestion(mensaje, 'Identificador propuesto')
                .then((result) => {
                  if (result.value) {
                    this.onConfirmarAviso();
                  }
                });
            }
          }
        },
        (error) => {
          console.error(error);
          this.loading = false;
          this._messageDialog.ShowAlert(error);
        }
      );
  }

  cargarCentros(companyCode: string) {
    this._A3LCompanyService.getWorkplaces(companyCode, null).subscribe(
      (response: PageList<A3LCompanyWorkplaces>) => {
        if (response) {
          this.centros = response.pageData.sort((a, b) => a.workplaceName.localeCompare(b.workplaceName));
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getTiposTrabajador() {
    this._A3LCommonService.getPersonTypes().subscribe(
      (response) => {
        if (response) {
          this.personTypes = response.sort(this.sortFunction).filter(
            (tipo) => tipo.description !== this.TIPO_TRABAJADOR_ETT
          );
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getSexos() {
    this._A3LCommonService.getSexTypes().subscribe(
      (response) => {
        if (response) {
          this.sexTypes = response.sort(this.sortFunction);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getTiposIdentificacion() {
    this._A3LCommonService.getIdentificationTypes().subscribe(
      (response: A3LCommonDataEntity[]) => {
        if (response) {
          this.identificationTypes = response.sort(this.sortFunction);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getJobPositions() {
    this._A3LCompanyService
      .getJobPositions(this.selectedCompany.toString())
      .subscribe(
        (response: A3LCompanyAvailableJobPositions[]) => {
          if (response) {
            this.jobPositions = response.sort((a, b) => a.jobDescription.localeCompare(b.jobDescription));
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  getRegimes() {
    this._A3LCompanyService
      .getRegimes(this.selectedCompany.toString())
      .subscribe(
        (response) => {
          if (response) {
            this.regimes = response;

            try {
              if(this.regimes)
                {
                  this.regime = this.regimes[0].regimeID;
                  this.getTariffGroups(this.regime);
                }
            } catch (error) {
              console.error("No se ha podido asignar el Regimen general");
            }

            this.regimes = response.sort((a, b)=> a.description.localeCompare(b.description))
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  getCompanyAgreements() {
    this._A3LCompanyService
      .getAgreements(this.selectedCompany.toString())
      .subscribe(
        (response: A3LCompanyAgreements[]) => {
          if (response) {
            this.companyAgreements = response.sort((a, b) => a.description.localeCompare(b.description));
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  getTariffGroups(regimeId: string) {
    this._A3LCompanyService
      .getTariffGroups(this.selectedCompany.toString(), regimeId)
      .subscribe(
        (response) => {
          if (response) {
            this.tariffGroups = response;
            this.tariffGroups = this.tariffGroups.sort((a, b) => {
              const idA =  Number.parseInt(a.contributionGroupID);
              const idB =  Number.parseInt(b.contributionGroupID);
              if(idA > idB)
                return 1;
              if(idA < idB)
                return -1;

              return 0;
            })
            if(this.tariffGroups) {
              this.tariffGroup = this.GRUPO_TARIFA_OFICIALES_PRIMERA_SEGUNDA.toString();
            }
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  getContributionTypes() {
    this._A3LCommonService.getContributionTypes().subscribe(
      (response) => {
        if (response) {
          this.contributionTypes = response
            .filter(type => type.id === this.TIPO_COTIZACION_GENERAL.toString())
            .sort(this.sortFunction);

          if(this.contributionTypes) {
            this.contributionType = this.TIPO_COTIZACION_GENERAL.toString();
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  onNifBlur(value: string) {

    if(!value)
      return;

    this.empleadoExiste = false;

    if (this.isIdentificationDocumentValid(value)) {
      this.nifValido = true;
    } else {
      this.nifValido = false;
      return;
    }

    this.employeeExists(value);
  }

  onTipoDocumentoChange(event): void {
    this.nif = '';
    this.empleadoExiste = false;
    this.nifValido = true;
  }

  isIdentificationDocumentValid(value: string) {
    value = value.toUpperCase();

    switch (+this.tipoDocumento) {
      case EIdentificationType.DNI_NIF:
      case EIdentificationType.NIFMenor:
      case EIdentificationType.NIFRepresentanteMenor:
        if (!isValidNif(value)) {
          this._messageDialog.ShowAlert('El formato del DNI es incorrecto');
          return false;
        }
        break;

      case EIdentificationType.CIF:
        if (!isValidCif(value)) {
          this._messageDialog.ShowAlert('El formato del CIF es incorrecto');
          return false;
        }
        break;

      case EIdentificationType.NIE:
        if (!isValidNie(value)) {
          this._messageDialog.ShowAlert('El formato del NIE es incorrecto');
          return false;
        }
        break;
    }

    return true;
  }

  onInputIdentification(event: Event) {
    const input = (event.target as HTMLInputElement);
    let value = input.value.toUpperCase();
  
    switch (+this.tipoDocumento) {
      case EIdentificationType.DNI_NIF:
      case EIdentificationType.NIFMenor:
      case EIdentificationType.NIFRepresentanteMenor:
        value = value.replace(/[^0-9A-Za-z]/g, '');
      
        if (value.length > 8) {
          const numericPart = value.slice(0, 8).replace(/\D/g, '');
          const letterPart = value.slice(8).replace(/[^A-Za-z]/g, '');
          value = numericPart + letterPart.slice(0, 1);
        } else {
          const hasLetter = /[A-Za-z]$/.test(value);
          if (hasLetter) {
            const numericPart = value.replace(/[^0-9]/g, '');
            const letterPart = value.match(/[A-Za-z]/g);
      
            value = numericPart + (letterPart ? letterPart[0] : '');
          } else {
            value = value.replace(/\D/g, '');
          }
        }
        break;
      case EIdentificationType.CIF:
        break;
      case EIdentificationType.NIE:
        value = value.replace(/[^A-Za-z0-9]/g, '');

        if (value.length > 0) {
            const initialLetter = value.charAt(0).match(/[XYZ]/) ? value.charAt(0) : '';
            const numericPart = value.slice(1, 8).replace(/\D/g, '');
            const finalLetters = value.slice(1).match(/[A-Za-z]/g);
            const finalLetter = finalLetters ? finalLetters[finalLetters.length - 1] : '';
            value = initialLetter + numericPart + finalLetter.slice(0, 1);
        }

        if (value.length > 9) {
            value = value.slice(0, 9);
        }

        input.value = value;
        this.nif = value;
        break;
      default:
        break;
    }
  
    input.value = value;
    this.nif = value;
  }

  employeeExists(nif: string) {
    this._employeeService
      .employeeExists(this.selectedCompany.toString(), nif)
      .subscribe(
        (response) => {
          let exists = response;
          this.empleadoExiste = exists;
          let icon: SweetAlertIcon = 'warning';
          let message = '';
          if (exists) {
            message = 'Ya existe un empleado con ese documento de identificación.';
          } else {
            message = 'No existe ningún empleado con ese documento de identificación.';
            icon = 'success';
          }

          this._messageDialog.ShowMessage(message, '', icon);
        },
        (error) => {
          console.error(error);
        }
      );
  }

  actualizarEmpleado() {
    const request: A3LEmployeeIdentificationDataUpdateRequest =
      this.updateRequest();

    this._employeeService
      .putIdentificationData(this.selectedCompany.toString(), this.id, request)
      .subscribe(
        () => {
          this._messageDialog.ShowMessage(
            'Empleado actualizado correctamente.',
            'Actualizado'
          );
        },
        (error) => {
          console.error(error);
          this._messageDialog.ShowAlert(
            'Ha ocurrido un error en la actualización del empleado.',
            'Error'
          );
        }
      );
  }

  onCompanyChange(selectedCompany: number): void {
    if (selectedCompany) {
      this.cargarCentros(selectedCompany.toString());
      this.getJobPositions();
      this.getRegimes();
      this.getCompanyAgreements();
      this.getContributionTypes();
    }
  }

  onRegimeChange(regimeId: string) {
    this.getTariffGroups(regimeId);
  }

  crearMensajeAviso(
    tipoTrabajador: string,
    ultimoCodigoActual: string,
    codigoAsignado: string,
    tramoSuperado: boolean
  ) {
    let tipoEmpleadoMensaje = `Para el tipo de empleado <b>${tipoTrabajador}</b> el último código
      de empleado actual es el <b>${ultimoCodigoActual}</b>.`;
    this.tramoSuperado = tramoSuperado;

    if (tramoSuperado) {
      this.avisoMensaje =
        tipoEmpleadoMensaje +
        ` No es posible crear un empleado debido a que el código máximo establecido en los tramos para este tipo de empleado sería superado.`;
    } else {
      if (!ultimoCodigoActual) {
        tipoEmpleadoMensaje = `No se han encontrado empleados de tipo <b>${tipoTrabajador}</b>.`;
      }

      this.avisoMensaje = `${tipoEmpleadoMensaje} Si finaliza la creación de este
        empleado, el código asignado al mismo será el <b>${codigoAsignado}</b>.`;
    }
  }

  onConfirmarAviso() {
    const request: A3LEmployeeCreateRequest = this.createRequest();
    const companyCode = this.selectedCompany.toString();
    const employeeCode = request.identification.employeeCode;

    this.loading = true;

    this._employeeService.checkEmployeeCode(companyCode, employeeCode)
      .subscribe((exists) => {
        if (exists) {
          this._messageDialog.ShowAlert(
            `El código de empleado ${employeeCode} ya existe en la base de datos. 
            El código propuesto anteriormente ya ha sido propuesto por otro usuario.
            Es necesario que vuelva a guardar para generar una nueva propuesta de código.`,
            'Error'
          );
        this.loading = false;
        } else {
          this.createEmployee(request);
          this.loading = false;
        }
      },
      (error) => {
        console.error(error);
        this.loading = false;
        this._messageDialog.ShowAlert(
          'Error al verificar el código de empleado.',
          'Error'
        );
      }
    );
  }

  createEmployee(request: A3LEmployeeCreateRequest) {
    this._employeeService
      .createEmployee(this.selectedCompany.toString(), request, EEntityMode.Single)
      .subscribe(
        (response) => {
          if (response) {
            this._messageDialog.ShowMessage(
              `Se ha creado correctamente el empleado con el código propuesto: ${request.identification.employeeCode}.`,
              ''
            );
            this.mostrarAvisos = false;
            this._router.navigate(['/home/employee/gestion-empleados/empleados']);
            this.isNew = false;
          }
        },
        (error) => {
          console.error(error);
          const parsedObject = JSON.parse(error.ErrorDescription);
          this._messageDialog.ShowAlert(
            `No se ha podido crear el empleado, motivo: ${parsedObject.message}`,
            'Error'
          );
        }
      );
  }

  updateRequest(): A3LEmployeeIdentificationDataUpdateRequest {
    const ssNumber = this.processSSNumber(this.numAfiliacion);

    const identification: A3LEmployeeIdentificationDataUpdateRequest = {
      sex: this.sexo,
      ssAffiliationNumberPrefix: Number(ssNumber.prefix),
      ssAffiliationNumber: Number(ssNumber.main),
      ssAffiliationNumberSuffix: Number(ssNumber.suffix),
      personTypeID: this.tipoTrabajador,
      identifierNumber: this.nif,
      givenName: this.nombre,
      secondName1: this.apellido1,
      secondName2: this.apellido2 ?? '',
      workplaceCode: this.centro.toString(),
    };

    return identification;
  }

  formatDate(date: Date): Date {
    const hoursDiff = date.getHours() - date.getTimezoneOffset() / 60;
    const minutesDiff = (date.getMinutes() - date.getTimezoneOffset()) % 60;
    date.setHours(hoursDiff);
    date.setMinutes(minutesDiff);

    return date;
  }

  createRequest(): A3LEmployeeCreateRequest {
    const ssNumber = this.processSSNumber(this.numAfiliacion);

    const identification: A3LEmployeeIdentificationCreateRequest = {
      identificationType: this.tipoDocumento,
      identifierNumber: this.nif,
      employeeCode: this.codEmpleado,
      legalName: this.nombre,
      secondName1: this.apellido1,
      secondName2: this.apellido2 ?? '',
      sex: this.sexo,
      ssAffiliationNumberPrefix: ssNumber.prefix,
      ssAffiliationNumber: ssNumber.main,
      ssAffiliationNumberSuffix: ssNumber.suffix,
      enrollmentDate: this.formatDate(this.fechaAlta),
      personType: this.tipoTrabajador,
      birthRegion: '',
      birthCountry: '',
    };

    const address: A3LEmployeeAddress = {
      streetName: this.calle,
      acronym: null,
      buildingNumber: null,
      stairwell: null,
      floor: null,
      gate: null,
      town: null,
      postalCode: null,
      countryID: null,
      poBox: null,
    };

    const contribution: A3LEmployeeContribution = {
      contributionTypeID:  Number.parseInt(this.contributionType),
      regime: this.regime,
      tariffGroupID: Number.parseInt(this.tariffGroup),
      occupationCodeTGSS: null,
      ims: this.ims,
      it: this.it,
      paymentFrequency: this.paymentFrequency,
    };

    const agreement: A3LEmployeeAgreementCreateRequest = {
      nonRenumerated: false,
      companyAgreementCode: this.companyAgreement,
      classificationCode: this.classificationCode,
      jobPositionCode: this.jobPosition,
      subClassificationCode: this.subClassificationCode,
      cnoOccupationID: null,
    };

    const request: A3LEmployeeCreateRequest = {
      workplaceCode: this.centro.toString(),
      identification: identification,
      agreement: agreement,
      contribution: contribution,
      address: address,
    };

    return request;
  }

  validateSSNumber(ssNumber: string): boolean {
    const ssNumberRegex = /^(\d{2})\/(\d{8})\/(\d{2})$/;
    return ssNumberRegex.test(ssNumber);
  }

  processSSNumber(ssNumber: string): {
    prefix: string;
    main: string;
    suffix: string;
  } {
    const parts = ssNumber.split('/');
    const [prefix, main, suffix] = parts;

    return { prefix, main, suffix };
  }

  validarFecha = (fecha: Date | null): boolean => {
    if (!fecha) {
      return false;
    }

    const formatoValido = /^\d{2}\/\d{2}\/\d{4}$/;
    const fechaStr = this.formatearFecha(fecha);

    return formatoValido.test(fechaStr);
  };

  formatearFecha(fecha: Date): string {
    const dia = ('0' + fecha.getDate()).slice(-2);
    const mes = ('0' + (fecha.getMonth() + 1)).slice(-2);
    const anio = fecha.getFullYear();
    return `${dia}/${mes}/${anio}`;
  }

  onDateInput(event: any): void {
    this.fechaValida = false;
    let input = event.target.value;

    if (input.length >= 10) {
      input = input.slice(0, 10);
    }

    input = input.replace(/\D/g, '');

    const dia = input.slice(0, 2);
    const mes = input.slice(2, 4);
    const anio = input.slice(4, 8);

    let formattedInput = '';
    if (dia) formattedInput += dia;
    if (dia && mes) formattedInput += '/';
    if (mes) formattedInput += mes;
    if (mes && anio) formattedInput += '/';
    if (anio) formattedInput += anio;

    event.target.value = formattedInput;

    if (formattedInput.length === 10) {
      const partes = formattedInput.split('/');
      const dia = parseInt(partes[0], 10);
      const mes = parseInt(partes[1], 10) - 1;
      const anio = parseInt(partes[2], 10);
      
      const fecha = new Date(anio, mes, dia);
      const esFechaValida = this.validarFecha(fecha);
  
      this.fechaValida = esFechaValida;
      this.fechaAlta = fecha;
    }
  }

  onNumAfiliacionInput(event: any): void {
    let input = event.target.value;

    if (input.length >= 14) {
      input = input.slice(0, 14);
    }

    input = input.replace(/\D/g, '');

    const parte1 = input.slice(0, 2);  // XX
    const parte2 = input.slice(2, 10); // YYYYYYYY
    const parte3 = input.slice(10, 12); // ZZ

    let formattedInput = '';
    if (parte1) formattedInput += parte1;
    if (parte1 && parte2) formattedInput += '/'; 
    if (parte2) formattedInput += parte2; 
    if (parte2 && parte3) formattedInput += '/';
    if (parte3) formattedInput += parte3; 

    event.target.value = formattedInput;
    this.numAfiliacion = formattedInput;
  }

  afterModelLoad(): void {
    throw new Error('Method not implemented.');
  }
  afterModelUpdated(success: boolean): void {
    throw new Error('Method not implemented.');
  }
  afterModelCreated(success: boolean): void {
    throw new Error('Method not implemented.');
  }
  getModelInstance(): A3LEmployee {
    throw new Error('Method not implemented.');
  }
}
